// The content search returns a bounded set of best matches. When that budget
// fills, a thread that matches only by message text can be missing from the
// list, and a coordinator would otherwise read its absence as "no such
// conversation". Say so, and say what narrows the search.
export function ConversationsInboxSearchNotice({
    contentMatchTruncated,
}: {
    readonly contentMatchTruncated: boolean;
}) {
    if (!contentMatchTruncated) {
        return null;
    }
    return (
        <p
            className="text-muted-foreground px-2 py-3 text-center text-xs"
            role="status"
        >
            Showing the closest message matches. Add a name or more words to
            narrow the search.
        </p>
    );
}
